export var SearcherId;
(function(SearcherId) {
    SearcherId["FLI_HOT"] = "FLI_HOT";
    SearcherId["TRA_HOT"] = "TRA_HOT";
    SearcherId["FER_HOT"] = "FER_HOT";
    SearcherId["MUL_PAK"] = "MUL_PAK";
    SearcherId["TOU"] = "TOU";
    SearcherId["LEI"] = "LEI";
    SearcherId["CIR"] = "CIR";
    SearcherId["CRU"] = "CRU";
    SearcherId["DIS"] = "DIS";
    SearcherId["FLI"] = "FLI";
    SearcherId["FER"] = "FER";
    SearcherId["HOT"] = "HOT";
    SearcherId["TRA"] = "TRA";
    SearcherId["CAR"] = "CAR";
    SearcherId["ACTIVITIES"] = "ACTIVITIES";
    SearcherId["DEST"] = "DEST";
})(SearcherId || (SearcherId = {}));

//# sourceMappingURL=searchers.js.map